/* eslint-disable react/require-default-props */
import { Row, Modal, Button } from 'react-materialize';
import ButtonUI from './ButtonUI';
import { translate } from '../../utils/util';

const ModalUI = (props) => {
    const {
        open,
        id = 'Modal-UI',
        maxHeight = '60%',
        dismissible,
        btnCancel,
        onCancel,
        disabledCancel,
        onConfirm,
        btnConfirm,
        closeModal,
        title,
        content,
        children,
    } = props;

    const renderAction = () => {
        if (btnCancel || onConfirm) {
            return (
                <Row className="center" style={{ height: maxHeight }}>
                    {btnCancel && (
                        <Button
                            onClick={onCancel}
                            className="col s6 btn waves-effect waves-light btn-flat"
                            modal="close"
                            disabled={disabledCancel}
                        >
                            {btnCancel || translate('cancel', 'general')}
                        </Button>
                    )}
                    {onConfirm && (
                        <ButtonUI
                            onClick={onConfirm}
                            text={btnConfirm || translate('confirm', 'general')}
                        />
                    )}
                </Row>
            );
        }
        return "";
    };

    const renderContent = () => {
        if ((title || content) && !children) {
            return (
                <Row className="center">
                    <div className="sixth-text-color center">
                        <span className="col s12">
                            <i className="material-icons large">info_outline</i>
                        </span>
                        {title && <span className="title col s12">{title}</span>}
                        {content && <span className="col s12">{content}</span>}
                    </div>
                </Row>
            );
        }
        return "";
    };

    return (
        <Modal
            open={open}
            id={id}
            fixedFooter={maxHeight !== "auto" && Boolean(btnCancel || onConfirm)}
            style={{ marginTop: "10px", maxHeight }}
            options={{ dismissible }}
            actions={renderAction()}
        >
            <div>
                {closeModal && (
                    <div className="close-button sixth-text-color right" style={{ cursor: 'pointer' }}>
                        <i onClick={closeModal} style={{ cursor: 'pointer' }} className="mdi mdi-close" />
                    </div>
                )}
                {renderContent()}
                {children}
            </div>
        </Modal>
    );
};

export default ModalUI;